import { Component, Inject, OnInit } from '@angular/core';
import { ValidacionComponent } from '../../validacion.component';

@Component({
  selector: 'app-informe-seguimiento',
  templateUrl: './informe-seguimiento.component.html',
  styleUrls: ['./informe-seguimiento.component.css']
})
export class InformeSeguimientoComponent implements OnInit {


  ngOnInit(): void {
  }

 
}